import {jsx as _jsx} from "react/jsx-runtime";import * as RadixDialog from '@radix-ui/react-dialog'
import {forwardRef} from 'react'
import {cn} from '../cn'

export const DialogTitle = forwardRef


(({className, children, ...props}, ref) => (
  _jsx(RadixDialog.Title, { ref: ref, className: cn('m-0 font-semibold text-xl', className), ...props, children: 
    children
  })
))
